import React from "react";
import FormGroup from "features/shared/forms/components/FormGroup";
import FormFieldProps from "features/shared/forms/dynamicForm/models/FormFieldProps";
import { useTranslation } from "react-i18next";
import {
  getDynamicFieldBlurHandler,
  getInputGroupProps,
  getTranslatedText,
  getTranslatedTooltip,
} from "features/shared/forms/dynamicForm/helpers/dynamicFormHelper";
import InputGroup from "features/shared/forms/components/inputGroup/InputGroup";

const TextBoxField = ({ descriptor, formHandler }: FormFieldProps) => {
  // translations
  const t = useTranslation("shared\\dynamicForms").t;

  // form hook props
  const { bindFieldNew, errors, validateFormField } = { ...formHandler };

  // render
  return (
    <div className={descriptor.className}>
      <FormGroup
        labelText={getTranslatedText(descriptor, "label", t)}
        validationError={errors ? errors[descriptor.name] : undefined}
        tooltip={getTranslatedTooltip(descriptor, t)}
      >
        <InputGroup {...getInputGroupProps(descriptor)}>
          <input
            className="form-control"
            placeholder={getTranslatedText(descriptor, "placeholder", t)}
            onBlur={getDynamicFieldBlurHandler(descriptor, validateFormField)}
            {...bindFieldNew(descriptor.name)}
          />
        </InputGroup>
      </FormGroup>
    </div>
  );
};

export default TextBoxField;
